import { render } from "./Box2.vue?vue&type=template&id=73582310&scoped=true"
import script from "./Box2.vue?vue&type=script&lang=js"
export * from "./Box2.vue?vue&type=script&lang=js"

import "./Box2.vue?vue&type=style&index=0&id=73582310&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73582310"]])

export default __exports__